import { Chip, styled } from '@mui/material';
import { defaultChipColor } from 'themes/colors';

export const StyledChip = styled(Chip)`
  /* Design system spec is 6px (INV-4270). */
  border-radius: 6px;
  font-size: 1rem;
  font-family: 'SF Pro Text', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding: 8px 3px;
  height: 28px;
  font-weight: 500;
  letter-spacing: 0.4px;

  &.MuiChip-colorDefault {
    color: ${defaultChipColor};
  }
`;

export const StyledStatusChip = styled(Chip)`
  height: 18px;
  background-color: rgba(20, 93, 160, 0.2);
  color: #145da0;
  font-weight: 600;
  font-size: 12px;
  font-family: 'Open Sans', sans-serif;
`;

export const StyledNumberChip = styled(StyledChip)`
  background-color: #e6e8f0;
  border: 1px solid #c0c7ca;
`;

export const StyledErrorChip = styled(StyledChip)`
  background-color: rgba(196, 77, 86, 0.30);
  border: 1px solid #C44D56;
`;